export const shouldForwardProps =
	(blockedProps: string[]) =>
	(prop: string): boolean =>
		!blockedProps.includes(prop);
